import { SERVER_STATIC_FILES_URL } from '@/globals';
import { TsunamiTheme, useGetThemeQuery } from '@/graphql';
import DEFAULT_TSUNAMI_THEME from '../assets/default-tsunami-theme.json';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import { setLogo } from '@/store/logoSlice';
import { useEffect, useRef } from 'react';

export function useCustomerTheme() {
  const { data } = useGetThemeQuery();
  // @ts-ignore
  const theme: Omit<TsunamiTheme, 'customerId' | 'themeId'> =
    data?.customerTheme ?? DEFAULT_TSUNAMI_THEME;
  return theme;
}

export function useCustomerLogo() {
  const dispatch = useDispatch();
  const logoUrl = useSelector((state: RootState) => state.logo.logoUrl);
  const theme = useCustomerTheme();

  // Track the previous theme using useRef
  const previousThemeRef = useRef(theme);

  useEffect(() => {
    // Check if the theme has changed
    if (theme !== previousThemeRef.current) {
      previousThemeRef.current = theme; // Update the ref to the current theme

      // Compute the logo URL
      const computedLogo = theme?.logo ? SERVER_STATIC_FILES_URL + '/' + theme.logo : null;

      // Only update Redux if the computed logo is different from the current logo in the store
      if (computedLogo && computedLogo !== logoUrl) {
        dispatch(setLogo(computedLogo));
      }
    }
  }, [theme, logoUrl, dispatch]);

  return logoUrl;
}
